var map = {
	"./sticker_auora_letter_a.png": 2206,
	"./sticker_auora_letter_b.png": 7264,
	"./sticker_auora_letter_c.png": 3603,
	"./sticker_auora_letter_d.png": 8922,
	"./sticker_auora_letter_e.png": 4087,
	"./sticker_auora_letter_f.png": 2031,
	"./sticker_auora_letter_g.png": 8821,
	"./sticker_auora_letter_h.png": 1923,
	"./sticker_auora_letter_i.png": 4718,
	"./sticker_auora_letter_j.png": 9017,
	"./sticker_auora_letter_k.png": 5620,
	"./sticker_auora_letter_l.png": 2445,
	"./sticker_auora_letter_m.png": 6473,
	"./sticker_auora_letter_n.png": 5899,
	"./sticker_auora_letter_o.png": 2614,
	"./sticker_auora_letter_p.png": 9712,
	"./sticker_auora_letter_q.png": 4760,
	"./sticker_auora_letter_r.png": 4172,
	"./sticker_auora_letter_s.png": 106,
	"./sticker_auora_letter_t.png": 2977,
	"./sticker_auora_letter_u.png": 5095,
	"./sticker_auora_letter_v.png": 734,
	"./sticker_auora_letter_w.png": 90,
	"./sticker_auora_letter_x.png": 427,
	"./sticker_auora_letter_y.png": 2095,
	"./sticker_auora_letter_z.png": 3306
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2465;